import alert from "components/elements/Alert";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import useOptions from "features/masterData/hooks/useOptions";
import { generateRandomString } from "utils/helper";
import { FORM_STEP, REGISTER_DOCUMENT } from "../schemas/signUpSchema";
import { signUp } from "../services/signUpApi";
import { setIsLoading, setIsLogin } from "../slices/signUpSlice";
import { getTaxConpany } from "features/masterData/services/optionsApi";
import { Alert } from "components/elements";
import debounce from "lodash.debounce";
import { message } from "antd";
import { useTranslation } from "react-i18next";

const convertFormValuesToServer = (values) => {
  const lang = window.localStorage.getItem("lang") || "en";
  const payload = {
    requestId: generateRandomString(),
    registerType: values.registerType, // OTHER DOMESTIC
    taxId: values.taxId || null,
    companyName: values.companyName,
    companyNameEn: values.companyName,
    companyTypeId: values.businessType,
    numberOfEmployees: values.numberOfEmployees + "",
    language: lang === "en" ? "EN" : "TH", // TH EN
    name: values.name,
    nameEn: values.name,
    surName: values.surName,
    surNameEn: values.surName,
    email: values.email,
    mobileNumber: values.phoneNo.mobileNumber,
    mobileCodeId: values.phoneNo.mobileCodeId,
    address: values.address,
    provinceId: values.province,
    districtId: values.district,
    subDistrictId: values.subDistrict,
    zipCode: values.postalCode,
    idCardType: values.idCardType, // OTHER DOMESTIC
    idCardNumber: values.idCardNumber
    //   values.registerDoc == REGISTER_DOCUMENT.CITIZENID
    //     ? values.citizenId
    //     : null,
    // passportNo:
    //   values.registerDoc == REGISTER_DOCUMENT.CITIZENID
    //     ? null
    //     : values.passportNo,
  };
  return payload;
};

function useSignUp() {
  const { t } = useTranslation();
  const isLoading = useSelector((state) => state.signUp.isLoading);
  const isLogin = useSelector((state) => state.signUp.isLogin);
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [optionSearchTax, setOptionSearchTax] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const {
    companyTypeOptions = [],
    provinceOptions = [],
    districtOptions = [],
    subDistrictOptions = [],
    getMstCompanyTypeOptions,
    getProvinceOptions,
    getDistrictOptions,
    getSubDistrictOptions,
    clearDistrictOptions,
    clearSubDistrictOptions,
  } = useOptions();

  const [formValues, setFormValues] = useState({});
  const [formStep, setFormStep] = useState(FORM_STEP.info);

  const changeForm = useCallback(
    (page) => {
      setFormStep(page);
    },
    [setFormStep]
  );

  const onSubmitInfoForm = useCallback(
    (values) => {
      setFormValues({ ...formValues, ...values });
      setFormStep(FORM_STEP.address);
    },
    [formValues]
  );

  const doSignUp = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        dispatch(setIsLogin(false));
        const modifiedValues = {
          ...formValues,
          ...values,
          ...formValues.phoneNumber,
        };
        const convertedValues = convertFormValuesToServer(modifiedValues);
        let res = await signUp(convertedValues);
        console.log("resresresres", res);
        dispatch(setIsLogin(true));
        message.success(t("common.signup_success"))
        navigate("/login");
      } catch (error) {
        // console.log("error", error);
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [formValues, dispatch, navigate]
  );

  const handleProviceChange = useCallback(
    (val) => {
      clearDistrictOptions();
      clearSubDistrictOptions();
      if (val) {
        getDistrictOptions({ provinceId: val });
      }
    },
    [clearDistrictOptions, clearSubDistrictOptions, getDistrictOptions]
  );

  const handleDistrictChange = useCallback(
    (val) => {
      clearSubDistrictOptions();
      if (val) {
        getSubDistrictOptions({ districtId: val });
      }
    },
    [clearSubDistrictOptions, getSubDistrictOptions]
  );

  useEffect(() => {
    getMstCompanyTypeOptions();
    getProvinceOptions();
  }, [getMstCompanyTypeOptions, getProvinceOptions]);


  const getTaxConpanyOption = useCallback(debounce(
    async ({ searchtext = "" }) => {
      try {
        dispatch(setIsLoading(true));
        const values = {
          requestId: generateRandomString(),
          companyId: currentCompany,
          employeeId: currentEmployee,
          searchtext
        };
        const response = await getTaxConpany(values);
        console.log("response?.data", response?.data);
        // console.log("res", response?.data?.data?.map(o => {
        //   return {
        //     ...o,
        //     label: o?.fullNameTh,
        //     value: o?.taxId
        //   }
        // }));
        // setSwitchWithOptions(response.data);
        setOptionSearchTax(response?.data?.data?.result?.map(o => {
          return {
            ...o,
            fullNameTh: o?.companyName?.fullNameTh,
            fullNameEn: o?.companyName?.fullNameEn,
            label: o?.companyName?.fullNameTh,
            value: o?.id,
            taxId: o?.id,
          }
        }))
      } catch (error) {
        // console.log("error", error);
        // Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }, 1000), []);

  return {
    isLoading,
    isLogin,
    formStep,
    companyTypeOptions,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    changeForm,
    onSubmitInfoForm,
    doSignUp,
    handleProviceChange,
    handleDistrictChange,
    getTaxConpanyOption,
    optionSearchTax,
    isModalOpen,
    showModal,
    handleCancel
  };
}

export default useSignUp;
